import * as React from 'react';

import { IVacancy } from '../../index';
import { trackingAddVacancy } from '../../tracking/tracking';
import { PreloaderWrapper } from '../preloader_wrapper/preloader_wrapper';
import { VacancyForm } from '../vacancy_form/vacancy_form';
import * as styles from './add_vacancy.css';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { addVacancy } from '../../services/addVacancy';
import { ESubdomain } from '../../constants/domain';
import { IUser } from '../../types/user';
import { IRegion } from '../../types/region';

interface IAddVacancyProps {
  httpApi: IHttpApi;
  logger: ILogger;
  recaptchaSitekey: string;
  regions: IRegion[];
  user: IUser;
  useRecaptcha?: boolean;
}

interface IAddVacancyState {
  saveVacancyProcessing: boolean;
  isPublishError: boolean;
}

export class AddVacancy extends React.Component<IAddVacancyProps, IAddVacancyState> {
  public constructor(props: IAddVacancyProps) {
    super(props);

    this.state = {
      isPublishError: false,
      saveVacancyProcessing: false,
    };
  }

  public render() {
    return (
      <div className={styles['panel']}>
        <VacancyForm
          title="Опубликовать вакансию бесплатно"
          regions={this.props.regions}
          user={this.props.user}
          useRecaptcha={this.props.useRecaptcha}
          onSubmit={this.saveVacancy.bind(this)}
          recaptchaSitekey={this.props.recaptchaSitekey}
          isPublishError={this.state.isPublishError}
        />
        {this.state.saveVacancyProcessing && <PreloaderWrapper size={40} />}
      </div>
    );
  }

  private showProcessing() {
    this.setState({ saveVacancyProcessing: true });
  }

  private hideProcessing() {
    this.setState({ saveVacancyProcessing: false });
  }

  private saveVacancy(vacancy: IVacancy, recaptcha: string) {
    const { httpApi, logger } = this.props;
    this.showProcessing();
    addVacancy({ httpApi, logger, subdomain: ESubdomain.AddVacancy }, { vacancy, recaptcha })
      .then((id: number) => {
        trackingAddVacancy(id);
        window.location.pathname = `/vacancies/preview/${id}`;
      })
      .catch(() => {
        this.hideProcessing();
        this.setState({ isPublishError: true });
      });
  }
}
